import { __assign } from "tslib";
import hexToRgba from 'hex-rgba';
import spcColors from './spcColors';
import paletteDark from './paletteDark';
var black = spcColors.black,
    gray = spcColors.gray,
    white = spcColors.white,
    negative = spcColors.negative,
    accent = spcColors.accent,
    dark = spcColors.dark;

var limeDarkPalette = __assign(__assign({}, paletteDark), {
  background: {
    neutral: {
      primary: '#182338',
      secondary: '#1C2840',
      tertiary: '#0F1A2D',
      popover: '#1E2A40',
      primaryTransparent: 'rgba(24, 35, 56, 0.24)',
      tertiaryTransparent: 'rgba(31, 31, 33, 0.56)',
      dialogOverlay: 'rgba(5, 7, 15, 0.56)'
    },
    semantic: {
      warning: '#333332',
      accent: 'rgba(236, 250, 222, 0.15)',
      positive: '#1C3040',
      negative: '#372538',
      positiveGradient: 'linear-gradient(180deg, #141A26 0%, #152E36 50%, #133833 100%)',
      negativeGradient: 'linear-gradient(180deg, #1D1A26 0%, #2D202E 50.99%, #472E3A 100%)'
    },
    gradient: {
      primary: 'linear-gradient(180deg, #27272B 3.5%, rgba(39, 39, 43, 0) 96.51%)',
      secondary: 'linear-gradient(180deg, #2D2C30 3.5%, rgba(45, 44, 48, 0) 96.51%)',
      tertiary: 'linear-gradient(180deg, #1F1F21 3.5%, rgba(31, 31, 33, 0) 96.51%)'
    }
  },
  label: {
    accent: '#67B859',
    accentHigh: '#8AD166',
    accentHighest: '#A0D681',
    primary: '#F0F4F7',
    secondary: '#879DBE',
    secondaryHigh: '#9FB7E5',
    tertiary: '#5875A1',
    tertiaryHigh: '#7D91B5',
    placeholder: '#45608C',
    inactive: 'rgba(88, 122, 173, 0.5)',
    positive: '#45BA8D',
    negative: '#FF6164',
    warning: '#F7CC1E',
    inverse: '#15243D',
    primaryActive: '#67B859',
    secondaryActive: '#9FB7E5',
    tertiaryActive: '#7D91B5',
    plaseholder: '#45608C'
  },
  fill: __assign(__assign({}, paletteDark.fill), {
    primary: {
      highest: '#6DBF4C',
      high: '#5BA843',
      mid: '#49993A',
      low: '#3A733F',
      muted: '#2D5942',
      overlay32: 'rgba(61, 135, 78, 0.32)',
      overlay24: 'rgba(57, 135, 83, 0.24)',
      overlay16: 'rgba(53, 130, 79, 0.16)',
      overlay8: 'rgba(45, 150, 91, 0.08)'
    },
    secondary: {
      highest: '#DDE5ED',
      high: '#8EA2B7',
      mid: '#697D96',
      low: '#43546E',
      muted: '#364761',
      overlay32: 'rgba(81, 100, 125, 0.32)',
      overlay24: 'rgba(81, 100, 125, 0.24)',
      overlay16: 'rgba(83, 102, 128, 0.16)',
      overlay8: 'rgba(97, 118, 148, 0.08)'
    }
  }),
  divider: {
    primary: '#060F1C',
    secondary: '#0A1321',
    tertiary: '#010308',
    altPrimary: '#213047',
    altSecondary: 'rgba(33, 48, 71, 0.5)'
  },
  static: {
    backgroundPrimary: '#182338',
    black: '#0E1726',
    blackAlfa72: 'rgba(14, 23, 38, 0.72)',
    blackAlfa56: 'rgba(14, 23, 38, 0.56)',
    blackAlfa24: 'rgba(14, 23, 38, 0.24)',
    blackAlfa16: 'rgba(14, 23, 38, 0.16)',
    blackAlfa8: 'rgba(14, 23, 38, 0.08)',
    blackAlfa4: 'rgba(14, 23, 38, 0.04)',
    white: '#FFFFFF',
    whiteAlfa72: 'rgba(255, 255, 255, 0.72)',
    whiteAlfa56: 'rgba(255, 255, 255, 0.56)',
    whiteAlfa24: 'rgba(255, 255, 255, 0.24)',
    whiteAlfa16: 'rgba(255, 255, 255, 0.16)',
    whiteAlfa8: 'rgba(255, 255, 255, 0.08)',
    whiteAlfa4: 'rgba(255, 255, 255, 0.04)',
    primary: '#67B859',
    primaryAlfa32: 'rgba(92, 164, 79, 0.32)',
    secondary: '#879DBE',
    secondaryAlfa32: 'rgba(130, 151, 190, 0.32)',
    positive: '#4BBF93',
    negative: '#FF6B6E',
    note: '#FFCB30'
  },
  shadow: {
    button: '0px 1px 3px 0px rgba(0, 0, 0, 0)',
    accent: '0px 3px 6px -2px rgba(24, 98, 18, 0.38), 0px 6px 12px rgba(24, 98, 18, 0.27), 0px 8px 16px rgba(0, 0, 0, 0.6)',
    popover: '0px 4px 16px rgba(0, 0, 0, 0.7), 0px 16px 40px rgba(0, 0, 0, 0.32)',
    dialog: '0px 12px 16px rgba(5, 8, 16, 0.32), 0px 24px 56px rgba(5, 8, 16, 0.56)',
    cardEasy: '0px 6px 16px rgba(0, 0, 0, 0.2)',
    cardHeavy: '0px 1px 4px rgba(0, 0, 0, 0.2), 0px 6px 16px rgba(0, 0, 0, 0.4)',
    headerWeb: '0px 1px 4px rgba(0, 0, 0, 0.4), 0px 6px 16px rgba(0, 0, 0, 0.4)'
  },
  base: {
    accent: accent['1'],
    error: negative['2'],
    disabled: black['3']
  },
  input: {
    main: {
      text: white['2'],
      background: hexToRgba(gray['2'], 8),
      backgroundDisabled: hexToRgba(gray['2'], 4),
      backgroundHover: hexToRgba(gray['2'], 16),
      backgroundError: hexToRgba(negative['2'], 8),
      border: black['3'],
      borderDisabled: hexToRgba(black['3'], 56),
      borderHover: gray['1'],
      borderError: negative['2']
    },
    label: gray['2'],
    message: gray['2']
  },
  menuItem: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundSelected: hexToRgba(accent['1'], 16)
  },
  button: {
    backgroundDisabled: hexToRgba(gray['2'], 6),
    border: hexToRgba(accent['1'], 32),
    borderDisabled: hexToRgba(white['1'], 8)
  },
  iconButton: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundFocused: hexToRgba(accent['1'], 16)
  },
  toggle: {
    background: black['2'],
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundActivated: hexToRgba(accent['1'], 16)
  },
  text: {
    primary: white['2'],
    secondary: gray['2']
  },
  paper: __assign(__assign({}, paletteDark.paper), {
    background: black['2']
  }),
  modal: {
    backdrop: hexToRgba(black['0'], 50)
  },
  dialog: {
    background: black['2']
  },
  dropDown: {
    background: dark['1']
  },
  dividerLegacy: {
    primary: dark['5'],
    secondary: dark['6']
  },
  switch: {
    icon: gray['3'],
    shadow: paletteDark.switch.shadow,
    track: gray['2']
  },
  calendar: {
    day: {
      backgroundHover: hexToRgba(black['1'], 56),
      backgroundCurrent: hexToRgba(accent['1'], 16)
    }
  },
  avatar: {
    backgroundPrimary: black['0'],
    backgroundSecondary: black['1']
  },
  snackbar: {
    text: black['1'],
    background: white['2']
  },
  tooltip: {
    background: hexToRgba(black['0'], 90),
    color: white['1']
  }
});

export default limeDarkPalette;